import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RegistrationData } from "../../libs/models/registrationModel";

const initialState: RegistrationData = {
  subjectId: "",
  registrationType: undefined,
};

/* istanbul ignore next */
const registrationSlice = createSlice({
  name: "registrationState",
  initialState,
  reducers: {
    setOnLoadRegistrationData(state, action: PayloadAction<RegistrationData>) {
      state.subjectId = action.payload.subjectId;
      state.registrationType = action.payload.registrationType;
    },
    clearOnLoadRegistrationData(
      state,
      action: PayloadAction<RegistrationData>
    ) {
      state.subjectId = action.payload.subjectId;
      state.registrationType = action.payload.registrationType;
    },
  },
});
export const { setOnLoadRegistrationData, clearOnLoadRegistrationData } =
  registrationSlice.actions;
export default registrationSlice.reducer;
